require('./bootstrap');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

Vue.component('conversations-notifications', require('./components/ConversationsNotification.vue').default);
Vue.component('videocalls-notifications', require('./components/VideocallsNotification.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

if($('#app').length > 0) {
    const app = new Vue({
        el: '#app',
    });
}

$(document).ready(function() {
    // Mobile menu toggle
    $('.toggleMobileMenu').click(function(e) {
        e.preventDefault();
        $(this).toggleClass('opened');
        $($(this).attr('data-rel')).toggleClass('d-none');
    })

    $('.authMenuToggle').click(function(e) {
        e.preventDefault();
        $($(this).attr('data-rel')).toggleClass('d-none');
    });

    // Search Widget
    $('.subjectSearch').click(function(e) {
        e.preventDefault();
        $('.searchItemsListWrapper').addClass('d-none');
        $($(this).attr('data-rel')).removeClass('d-none');
    });
    $('.localitySearch').click(function(e) {
        e.preventDefault();
        $('.searchItemsListWrapper').addClass('d-none');
        $($(this).attr('data-rel')).removeClass('d-none');
    });
    $(window).click(function(e) {
        if (
            outsideClick(e, $('.subjectSearch')) && 
            outsideClick(e, $('.localitySearch')) &&
            outsideClick(e, $('.searchItemsListWrapper'))
        ) {
            $('.searchItemsListWrapper').addClass('d-none');
        }
    });
    $(document).on('click', '.searchResultFiltersToggle', function(e) {
        e.preventDefault();
        var target = $($(this).attr('data-rel'));
        if (target.hasClass('d-none')) {
            target.removeClass('d-none');
        } else {
            target.addClass('d-none');
        }
    });

    // Select 2 general init
    $('.select2').each(function(key, dropdownElement) {
        $(dropdownElement).select2({
            placeholder: $(dropdownElement).attr('placeholder'),
            language: 'it'
        });
    });

    // ScrollToTop
    $("a[href='#top']").click(function(e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    // Auth Login Type switcher
    $(".changeAuthType").click(function(e) {
        e.preventDefault();
        $('.auth-login-card').removeClass('active');
        $($(this).attr('data-rel')).toggleClass('active');
    });

    // ----------------------------------------
    // Add attribute checked
    // ----------------------------------------
    $(document).on('click', '.form-check:not(.form-check-switch) label', function() {
        $(this).parent().toggleClass('checked');
        var input = $(this).parent().find('input');
    });
    $('.form-check input[type="checkbox"]').each(function(index, checkboxItem) {
        if ($(checkboxItem).prop('checked')) {
            if (!$($(checkboxItem)).parent().hasClass('checked')) {
                $($(checkboxItem)).parent().toggleClass('checked');
            }
        }
    });
    $(document).on('click', '.form-check-radio label', function() {
        $(this).parent().addClass('checked');
        var input = $(this).parent().find('input');
        $(this).parent().siblings().removeClass('checked');
        $(this).parent().siblings().find('input').removeAttr('checked');
        input.attr('checked', 'checked');
    });

    // ----------------------------------------
    // Air Datepicker
    // ----------------------------------------
    if (jQuery('.datepicker.from-today').length) {
        jQuery('.datepicker.from-today').each(function(index, item) {
            let presetDate = jQuery(item).val() ? moment(jQuery(item).val(), 'DD/MM/YYYY') : [];
            new AirDatepicker('#' + jQuery(item).attr('id'), {
                locale: AirDatepickerLocaleIt,
                toggleSelected: true,
                autoClose: true,
                clearButton: true,
                selectedDates: presetDate,
                onRenderCell({date, cellType}) {
                    var today = moment().startOf('day');
                    if (date < today) {
                        return {
                            disabled: true
                        }
                    }
                }
            });
        });
    }

    const searchResultCardSwiper = new Swiper('.search-result-card-image-carousel .swiper', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        // If we need pagination
        spaceBetween: 14,
        pagination: {
            el: '.swiper-pagination',
        },
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });

    const supplierDetailCardSwiper = new Swiper('.supplier-detail-image-carousel .swiper', {
        // Optional parameters
        direction: 'horizontal',
        loop: false,
        slidesPerView: 6,
        spaceBetween: 14,
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });

    const homeSectionContentSwiper = new Swiper('.home-section-content-carousel .swiper', {
        // Optional parameters
        direction: 'horizontal',
        loop: false,
        slidesPerView: 3,
        spaceBetween: 16,
        // Navigation arrows
        navigation: false,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        breakpoints: {
            // when window width is >= 0
            0: {
                slidesPerView: 1,
                spaceBetween: 16
            },
            // when window width is >= 768px
            768: {
                slidesPerView: 2,
                spaceBetween: 16
            },
            // when window width is >= 992px
            992: {
                slidesPerView: 3,
                spaceBetween: 16
            }
        }
    });

    $('[data-toggle="tooltip"]').tooltip();

    // Echo events listening
    let userAuthCheck = ($('meta[name="user-auth-check"]').attr('content') === 'true');
    if (userAuthCheck) {
        let userId = $('meta[name="user-id"]').attr('content');
        Echo.private('Myosotis.Models.User.' + userId)
            .listen('VideoCallRequestCreated', (data) => {
                let status = data.isCreated ? 'success' : 'danger';
                let title = data.message.user;
                notifyFeedback(status, title);
            });
    }
    let supplierAuthCheck = ($('meta[name="supplier-auth-check"]').attr('content') === 'true');
    if (supplierAuthCheck) {
        let supplierId = $('meta[name="supplier-id"]').attr('content');
        let supplierCompanyId = $('meta[name="supplier-company-id"]').attr('content');
        if (supplierCompanyId !== '') {
            Echo.private('Myosotis.Models.SupplierCompany.' + supplierCompanyId)
                .listen('VideoCallRequestCreated', (data) => {
                    let status = data.isCreated ? 'success' : 'danger';
                    if (data.isCreated) {
                        let message = data.message.supplier;
                        notifyFeedback(status, title);
                    }
                });
        }
    }
});

$(window).scroll(function() {
    var noticeBarHeight = 0;
    if ($('.impersonateNoticeBar')) {
        var noticeBarHeight = $('.impersonateNoticeBar').offset();
        if (window.pageYOffset > 0) {
            $('.impersonateNoticeBar').addClass('sticky');
        } else {
            $('.impersonateNoticeBar').removeClass('sticky');
        }
    }
    if ($(this).scrollTop() > 100) {
        $('#scrollToTopContainer').fadeIn();
    } else {
        $('#scrollToTopContainer').fadeOut();
    }
});

function outsideClick(event, notelem)   {
    notelem = $(notelem); // jquerize (optional)
    // check outside click for multiple elements
    var clickedOut = true, i, len = notelem.length;
    for (i = 0;i < len;i++)  {
        if (event.target == notelem[i] || notelem[i].contains(event.target)) {
            clickedOut = false;
        }
    }
    if (clickedOut) return true;
    else return false;
}